import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  data: [],
  currentChoose: null,
  isShowBtnContinue: false,
}

export const vocabularySlice = createSlice({
  name: 'vocabulary',
  initialState,
  reducers: {
    updateData: (state, action) => {
      state.data = action.payload
    },
    updateIsCurrentChoose: (state, action) => {
      state.currentChoose = action.payload
    },
    updateIsShowBtnContinue: (state, action) => {
      state.isShowBtnContinue = action.payload
    },
    reset: () => {
      return initialState
    },
  },
})

export const {
  updateData,
  updateIsCurrentChoose,
  updateIsShowBtnContinue,
  reset,
} = vocabularySlice.actions

export default vocabularySlice.reducer
